/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable max-len */
import React, { forwardRef, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/rootState';
import ExpenseReport from '../ScreenReportPdf/components/ComponentsExpenseReport';
import ComponentReciepts from './ComponentReciepts';

const ExpenseComponentToPrint = forwardRef<HTMLDivElement>((props, ref) => {
  const {
    morningReportPdfData,
  } = useSelector((state:RootState) => state.dashboardReducer);

  const myData = useMemo(() => Object.values(morningReportPdfData), [morningReportPdfData]);

  return (
    <div
      ref={ref}
      className="morning-report-pdf"
      style={{
        width: '794px',
        margin: '0 auto',
        backgroundColor: '#FFFFFF',
        boxSizing: 'border-box',
      }}
    >
      {myData.map((dataItem, index) => (
        <div className="print-record">
          {/* <div className="w100"> */}
          {dataItem?.Expense_Report?.ExpenseReports?.length > 0 && <ExpenseReport isMorning dataItem={[dataItem?.Expense_Report]} />}
          {dataItem?.Expense_Receipt?.length > 0 && <div className="page-break" />}
          {dataItem?.Expense_Receipt?.length > 0 && <ComponentReciepts dataItem={dataItem?.Expense_Receipt} />}
          {index !== myData.length - 1 && <div className="page-break" />}
        </div>
      ))}
    </div>
  );
});

export default ExpenseComponentToPrint;
